import { useEffect, useRef } from 'react';
import { useWebRTC } from '../context/WebRTCContext';
import { useFeature } from './useFeatures';

/**
 * useTimelineBacklogSync — drives the Sacred Timeline offline event queue.
 *
 * The desktop's live event push silently drops while the frontend peer is
 * disconnected, so on every 0→N peer transition (a first connect or a reconnect
 * after a signaling drop) we ask the sacred-timeline feature to replay the gap
 * from the desktop DB. The feature dedupes against live events, so this is
 * exactly-once. Mount once, high in the tree (AppLayout); renders nothing.
 */
export function useTimelineBacklogSync() {
    const { connectedPeers } = useWebRTC();
    const feature = useFeature('sacred-timeline');
    const prevCountRef = useRef(0);
    const peerCount = connectedPeers?.length ?? 0;

    useEffect(() => {
        if (!feature) return;
        const wasDisconnected = prevCountRef.current === 0;
        prevCountRef.current = peerCount;
        if (wasDisconnected && peerCount > 0 && typeof feature.requestBacklog === 'function') {
            feature.requestBacklog();
        }
    }, [feature, peerCount]);
}
